/** =========================================================
 * Module: item-edit-dialog.directive.js
 * Edit item dialog
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.components')
    .directive('itemEditDialog', itemEditDialog);

  itemEditDialog.$inject = ['$rootScope', '$api', '$q', 'ngDialog', 'MainPreloader'];

  function itemEditDialog($rootScope, $api, $q, ngDialog, MainPreloader) {
    var directive = {
      restrict: 'A',
      link: link,
      scope: {
        config: '=',
        originalItem: '=item',
        template: '@?'
      }
    };

    return directive;

    function link($scope, element) {
      $scope.appConfig = $rootScope.appConfig;

      element.on('click', function () {
        if ($scope.config && $scope.config.model && $scope.config.edit && typeof $scope.originalItem !== 'undefined') {
          MainPreloader.show();

          $scope.item = angular.copy($scope.originalItem);

          // Setup resources
          $scope.resources = {};
          $scope.resourcesLoading = {};

          var resourcePromises = [];

          if (typeof $scope.config.resources !== 'undefined') {
            $scope.config.resources.forEach(function (resource) {
              var params = { order: { id: 'desc' } };

              if ($scope.config.resourceUpdateConditions && $scope.config.resourceUpdateConditions[resource]) {
                // Params
                if ($scope.config.resourceUpdateConditions[resource].params) {
                  params = $scope.config.resourceUpdateConditions[resource].params($scope.item);
                }

                // Selected
                if ($scope.config.resourceUpdateConditions[resource].selected) {
                  var selectedAttr = $scope.config.resourceUpdateConditions[resource].selected;

                  if (typeof selectedAttr === 'function') {
                    params.selected = selectedAttr($scope.item);
                  } else {
                    params.selected = selectedAttr;
                  }
                }

                // Resource watcher
                if ($scope.config.resourceUpdateConditions[resource].watch) {
                  var watchItem = $scope.config.resourceUpdateConditions[resource].watch;

                  $scope.$watch('item.' + watchItem, function (value) {
                    params[watchItem] = $scope.item[watchItem];

                    if (typeof value !== 'undefined') {
                      $scope.resourcesLoading[resource] = true;

                      $api.resource({
                        model: resource,
                        data: params
                      }).then(function (response) {
                        $scope.resources[resource] = response.data;
                        $scope.resourcesLoading[resource] = false;
                      });
                    } else {
                      $scope.resources[resource] = [];
                    }
                  });
                }
              }

              $scope.resourcesLoading[resource] = true;

              var resourcePromise = $api.resource({
                model: resource,
                data: params
              }).then(function (response) {
                $scope.resources[resource] = response.data;
                $scope.resourcesLoading[resource] = false;
              });

              resourcePromises.push(resourcePromise);
            });
          }

          var before = $rootScope.helpers.emptyPromise;
          var beforeSubmit = $rootScope.helpers.emptyPromise;
          var success = $rootScope.helpers.emptyPromise;
          var onClose = null;

          if (typeof $scope.config.edit !== 'undefined') {
            if (typeof $scope.config.edit.before === 'function') {
              before = $scope.config.edit.before;
            }

            if (typeof $scope.config.edit.beforeSubmit === 'function') {
              beforeSubmit = $scope.config.edit.beforeSubmit;
            }

            if (typeof $scope.config.edit.success === 'function') {
              success = $scope.config.edit.success;
            }

            if (typeof $scope.config.edit.onClose === 'function') {
              onClose = $scope.config.edit.onClose;
            }
          }

          $q.all(resourcePromises).then(function () {
            before($scope.item, $scope).then(function () {
              MainPreloader.hide();

              var width = '';

              if ($scope.config.edit.wide) {
                width += ' ngdialog-wide';
              } else if ($scope.config.edit.superWide) {
                width += ' ngdialog-super-wide';
              }

              ngDialog.openConfirm({
                template: $scope.template ? $scope.template : $scope.config.edit.template,
                className: 'ngdialog-theme-default' + width,
                scope: $scope,
                closeByDocument: false,
                closeByEscape: false
              }).then(function () {
                if (onClose) {
                  onClose($scope.item);
                }

                if ($scope.config.itemLoader) {
                  $scope.originalItem.loading = true;
                }

                beforeSubmit($scope.item).then(function (preparedItem) {
                  var attrs = {
                    model: $scope.config.model,
                    data: preparedItem
                  };

                  if (typeof $scope.config.edit.only !== 'undefined') {
                    attrs.only = $scope.config.edit.only;
                  }

                  if (typeof $scope.config.edit.except !== 'undefined') {
                    attrs.except = $scope.config.edit.except;
                  }

                  $api.update(attrs).then(function (response) {
                    success(response, preparedItem, $scope).then(function () {
                      // if (typeof $scope.config.getData === 'function' && $scope.config.getDataParams) {
                      //     $scope.config.getData();
                      // }
                    });
                  }, function (error) {
                    Raven.captureException(error);
                  });
                });
              });
            }, function () {
              if (onClose) {
                onClose($scope.item);
              }

              MainPreloader.hide();
            });
          }, function (error) {
            MainPreloader.hide();

            Raven.captureException(error);
          });
        }
      });
    }
  }
})();
